import React from 'react';

const TypographyListContext = React.createContext({});

export default TypographyListContext;
